"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var modalLoad_1 = require("./modalLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ModalLoadEventNames.ModalLoad] = modalLoad_1.modalLoadCreator,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
